import { Provider } from '@angular/core';
import { USER_SERVICE } from '../tokens/user-service.token';
import { UserService } from '../services/user.service';

export function provideUserService(): Provider {
    return {
        provide: USER_SERVICE,
        useClass: UserService
    };
}
